import { Component, OnInit } from "@angular/core";
import { AngularFirestore } from "@angular/fire/firestore";
import { UserManager } from "../../Services/UserManager/user-manager";
import { Translation } from "src/app/Models/translation.interface";
import { ActivatedRoute } from "@angular/router";
import { LanguageDraft } from "src/app/Models/language-models.interface";
import { AngularFireDatabase } from "@angular/fire/database";
import { Lesson } from "src/app/Models/lessons.interface";
import once from "lodash/once";

@Component({
  selector: "app-site-config",
  templateUrl: "./site-config.component.html",
  styleUrls: ["./site-config.component.css"],
})
export class SiteConfigComponent implements OnInit {
  englishConfig: Translation;
  otherConfig: Translation;
  draftConfig: LanguageDraft;
  draftLessons: Record<string, Lesson>;
  lang = "en";
  constructor(
    private afs: AngularFirestore,
    private um: UserManager,
    private route: ActivatedRoute,
    private db: AngularFireDatabase
  ) {}

  ngAfterViewInit() {
    this.um.getProfileSubject().subscribe((profile) => profile && this.setup());
  }

  ngOnInit(): void {
    this.lang = this.route.snapshot.paramMap.get("id") ?? "en";
  }

  setup = once(async () => {
    await this.getDraftConfig();
    // this.getEnglish();
    this.getOtherLanguageConfig(this.lang);
    this.getOtherLanguageLessons(this.lang);
  });

  getDraftConfig = (): Promise<void> => {
    return new Promise((resolve, reject) => {
      this.afs
        .collection("Languages")
        .doc(this.lang)
        .collection("Drafts", (ref) => ref.orderBy("version", "desc").limit(1))
        .get()
        .take(1)
        .subscribe((doc) => {
          this.draftConfig = doc.docs?.[0]?.data?.() as LanguageDraft;
          console.log("Got", this.lang);
          resolve();
        });
    });
  };

  getOtherLanguageConfig = (lang: string) => {
    if (lang === "en") {
      console.error("Language not found");
      return;
    }
    if (!this.draftConfig?.version) {
      console.error("Draft config not found");
      return;
    }
    this.afs
      .collection("Languages")
      .doc(lang)
      .collection("Drafts")
      .doc(String(this.draftConfig.version))
      .collection("Config")
      .get()
      .take(1)
      .subscribe((docs) => {
        const con = {};
        docs.docs.forEach((doc) => {
          con[doc.id] = doc.data();
        });

        this.otherConfig = con as Translation;
      });
  };

  getOtherLanguageLessons = (lang: string) => {
    if (lang === "en") {
      console.error("Language not found");
      return;
    }
    if (!this.draftConfig?.version) {
      console.error("Draft config not found");
      return;
    }
    this.afs
      .collection("Languages")
      .doc(lang)
      .collection("Drafts")
      .doc(String(this.draftConfig.version))
      .collection("Lessons")
      .get()
      .take(1)
      .subscribe((docs) => {
        const con = {};
        docs.docs.forEach((doc) => {
          con[doc.id] = doc.data();
        });

        this.draftLessons = con as Record<string, Lesson>;
      });
  };

  getEnglish = () => {
    this.afs
      .collection("Languages")
      .doc("en")
      .collection("Config")
      .get()
      .take(1)
      .subscribe((docs) => {
        const con = {};
        docs.docs.forEach((doc) => {
          con[doc.id] = doc.data();
        });
        this.englishConfig = con as Translation;
        if (this.lang === "en") this.otherConfig = this.englishConfig;
      });
  };
}
